import React, { useContext, useState, useEffect } from 'react';

// MUI components
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

// Section for import custom components
import SubTitle from '@components/common/SubTitle';
import RenovationVoiceDetail from '@components/RenovationVoice/RenovationVoiceDetail';
import RenovationVoiceDetailSP from '@components/RenovationVoice/SP/RenovationVoiceDetail';
import { AppConfigContext } from '@providers/AppConfigProvider';

import RenovationVoiceTypes from '@/types/components/RenovationVoice/RenovationVoice';

export default function RenovationVoice(): React.JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  const [renovationVoiceItems, setRenovationVoiceItems] = useState<RenovationVoiceTypes[]>([]);

  useEffect(() => {
    fetch('https://renovefudosan.com/api/articles?category=interview')
      .then((response) => response.json())
      .then((data) => setRenovationVoiceItems(data))
      .catch((error) => console.error('Error fetching data:', error));
  }, []);

  const topThreeItems = renovationVoiceItems
    .sort((a, b) => new Date(b.datePublished).getTime() - new Date(a.datePublished).getTime())
    .slice(0, 3);

  return (
    <Box className="md:mx-24">
      <Box className="max-md:ml-5">
        <SubTitle title="リノベーション体験談" />
      </Box>
      {isMobile ? (
        <List
          sx={{
            width: '100%',
            overflow: 'hidden',
            borderBottom: '0px solid',
            padding: '0',
          }}
          className="max-md:grid max-md:grid-rows-3 max-md:grid-flow-col max-md:gap-3"
        >
          {topThreeItems.map((voice, index) => (
            <ListItem
              key={voice['@context']}
              divider={index < 2}
              sx={{ justifyContent: 'space-between' }}
              className=" max-md:bg-white max-md:border-none max-md:px-0"
            >
              <RenovationVoiceDetailSP voice={voice} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Box className="flex gap-x-[30px]">
          {topThreeItems.map((voice) => (
            <Box className="w-1/3" key={voice['@context']}>
              <RenovationVoiceDetail voice={voice} />
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
}
